import { ClienteUnidadeNegocioSearchItemTipo } from '../item-tipo';

export class ClienteUnidadeNegocioSearchNaturezaVenda {
    id: number;
    createdAt: Date;
    idNaturezaVenda: number;
    nomeNaturezaVenda: string;
    situacaoNaturezaVenda: number;
    itensTipos: ClienteUnidadeNegocioSearchItemTipo[];

    constructor() {
        this.itensTipos = [];
    }
}
